import { ZodSchema } from 'zod';
import { invariantNotFound } from './invariant';

export function getSearchObject(request: Request) {
	return getSearchObjectFromParams(new URL(request.url).searchParams);
}

export function getSearchObjectFromParams(params: URLSearchParams) {
	const searchObj: Record<string, string> = {};
	for (const [key, value] of params) {
		// Convert stringified JSON to object
		try {
			searchObj[key] = JSON.parse(value);
		} catch (e) {
			searchObj[key] = value;
		}
	}

	return searchObj;
}

export function getSearchString(searchObj?: Record<string, any>, validator?: ZodSchema<Record<string, any>>) {
	if (!searchObj) return '';

	if (validator) {
		searchObj = validator.parse(searchObj);
	}

	const searchParams = new URLSearchParams();
	for (const [key, value] of Object.entries(searchObj)) {
		// Convert object to stringified JSON
		if (!value) continue;
		try {
			//Only stringify if it's not already a string or integer
			if (typeof value !== 'string' && typeof value !== 'number') {
				searchParams.append(key, JSON.stringify(value));
			} else {
				searchParams.append(key, value.toString());
			}
		} catch (e) {
			searchParams.append(key, value);
		}
	}

	if (![...searchParams].length) return '';

	return `?${searchParams.toString()}`;
}
